
export const storage = {
	set: function(key, value) {
		localStorage.setItem(key, JSON.stringify(value))
	},
	get: function(key) {
		const value = localStorage.getItem(key)
		if (value && value != "undefined" && value != "null") {
			return JSON.parse(value)
		} else {
			return null
		}
	},
	remove: function(key) {
		localStorage.removeItem(key)
	}
}

export const sessionStorage = {
	set: function(key, value) {
		window.sessionStorage.setItem(key, JSON.stringify(value))
	},
	get: function(key) {
		const value = window.sessionStorage.getItem(key)
		if (value && value != "undefined" && value != "null") {
			return JSON.parse(value)
		}
	},
	remove: function(key) {
		window.sessionStorage.removeItem(key)
	}
}
